import { empty, singleton, append, delay, toList, map } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { validatedTextBoxWithAttributes, validatedTextBox, errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { UserEditModel__get_CanSubmit, EditUserDialogMsg, Msg } from "./Types.fs.js";
import { length, empty as empty_1, map as map_1, toArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { toString, date } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { safeHash, equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { List_except } from "../../../fable_modules/fable-library-js.4.19.0/Seq2.js";
import { value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export function rolesAsTagsDesktop(roles) {
    return map((r) => {
        const props = [new HTMLAttr(65, ["tag is-light tooltip is-tooltip-multiline"]), ["data-tooltip", r.Beschreibung]];
        return react.createElement("span", keyValueList(props, 1), r.Bezeichnung);
    }, roles);
}

export function rolesAsTagsMobile(roles) {
    return map((r) => react.createElement("span", {
        className: "tag is-light",
    }, r.Bezeichnung), roles);
}

export function actionHoverMenu(dispatch, navigateTo, user) {
    let children_2, children, children_18, children_16;
    const menuName = toText(printf("dropdown-%i"))(user.KundenportalBenutzerId);
    const children_20 = [(children_2 = [(children = [icon("fas fa-ellipsis-v")], react.createElement("div", {
        "aria-haspopup": true,
        "aria-controls": menuName,
    }, ...children))], react.createElement("div", {
        className: "dropdown-trigger",
    }, ...children_2)), (children_18 = [(children_16 = toList(delay(() => {
        let props_4;
        return append(singleton((props_4 = [new HTMLAttr(65, ["dropdown-item"]), ["style", {
            fontWeight: "bold",
            textAlign: "center",
        }]], react.createElement("p", keyValueList(props_4, 1), user.Name))), delay(() => append(singleton(react.createElement("hr", {
            className: "dropdown-divider",
        })), delay(() => append(singleton(react.createElement("a", {
            className: "dropdown-item",
            onClick: (_arg) => {
                dispatch(new Msg(5, [user]));
            },
        }, "Passwort zurücksetzen")), delay(() => append(singleton(react.createElement("a", {
            className: "dropdown-item",
            onClick: (_arg_1) => {
                dispatch(new Msg(13, [user]));
            },
        }, "Benutzer bearbeiten")), delay(() => (!user.IsCurrentUser ? append(user.Gesperrt ? singleton(react.createElement("a", {
            className: "dropdown-item",
            onClick: (_arg_2) => {
                dispatch(new Msg(2, [user.KundenportalBenutzerId]));
            },
        }, "Benutzer entsperren")) : singleton(react.createElement("a", {
            className: "dropdown-item",
            onClick: (_arg_3) => {
                dispatch(new Msg(3, [user.KundenportalBenutzerId]));
            },
        }, "Benutzer sperren")), delay(() => singleton(react.createElement("a", {
            className: "dropdown-item",
            onClick: (_arg_4) => {
                dispatch(new Msg(8, [user]));
            },
        }, "Benutzer löschen")))) : empty())))))))));
    })), react.createElement("div", {
        className: "dropdown-content",
    }, ...children_16))], react.createElement("div", {
        className: "dropdown-menu",
        id: menuName,
        role: "menu",
    }, ...children_18))];
    return react.createElement("div", {
        className: "dropdown is-hoverable is-right is-up",
    }, ...children_20);
}

export function tableMobile(users, dispatch, navigateTo) {
    const children_20 = [toArray(map_1((u) => {
        let children_8, children_16, children_10, props_12, children_12, children_14;
        const children_18 = [(children_8 = toList(delay(() => append(singleton(react.createElement("div", {
            className: "dta-file",
        }, u.Name)), delay(() => append(u.Nutzt2Fa ? singleton(react.createElement("span", {
            className: "tag is-success",
        }, "2-Faktor-Login")) : empty(), delay(() => append(u.Gesperrt ? singleton(react.createElement("span", {
            className: "tag is-danger",
        }, "Gesperrt")) : empty(), delay(() => {
            let children_6;
            return singleton((children_6 = toList(delay(() => {
                let arg, copyOfStruct;
                const matchValue = u.LetzterLogin;
                return (matchValue != null) ? singleton((arg = ((copyOfStruct = date(matchValue), toString(copyOfStruct, "dd.MM.yyyy"))), toText(printf("Login: %s"))(arg))) : singleton("noch kein Login");
            })), react.createElement("div", {
                className: "dta-date",
            }, ...children_6)));
        })))))))), react.createElement("div", {}, ...children_8)), (children_16 = [(children_10 = [toText(printf("Benutzername: %s"))(u.Login)], react.createElement("div", {
            className: "word-break",
        }, ...children_10)), (props_12 = [["style", {
            marginTop: "5px",
        }]], (children_12 = rolesAsTagsMobile(u.BenutzerverwalteteRollen), react.createElement("div", keyValueList(props_12, 1), ...children_12))), (children_14 = [actionHoverMenu(dispatch, navigateTo, u)], react.createElement("div", {
            className: "pull-right",
        }, ...children_14))], react.createElement("div", {
            className: "dta-status",
        }, ...children_16))];
        return react.createElement("div", {
            className: "data-item",
        }, ...children_18);
    }, users))];
    return react.createElement("div", {
        className: "data-list is-hidden-desktop",
    }, ...children_20);
}

export function tableRow(dispatch, navigateTo, user) {
    let children_6, children_10, children_12, children_14;
    const children_16 = [(children_6 = toList(delay(() => append(singleton(react.createElement("div", {
        className: "word-break",
    }, user.Login)), delay(() => append(user.Nutzt2Fa ? singleton(react.createElement("span", {
        className: "tag is-success",
    }, "2-Faktor-Login")) : empty(), delay(() => (user.Gesperrt ? singleton(react.createElement("span", {
        className: "tag is-danger",
    }, "Gesperrt")) : empty()))))))), react.createElement("td", {}, ...children_6)), react.createElement("td", {}, user.Name), (children_10 = toList(delay(() => {
        let copyOfStruct;
        const matchValue = user.LetzterLogin;
        return (matchValue != null) ? singleton((copyOfStruct = date(matchValue), toString(copyOfStruct, "dd.MM.yyyy"))) : singleton("noch kein Login");
    })), react.createElement("td", {}, ...children_10)), (children_12 = rolesAsTagsDesktop(user.BenutzerverwalteteRollen), react.createElement("td", {}, ...children_12)), (children_14 = [actionHoverMenu(dispatch, navigateTo, user)], react.createElement("td", {
        className: "pull-right",
    }, ...children_14))];
    return react.createElement("tr", {
        className: "",
    }, ...children_16);
}

export function table(users, dispatch, navigateTo) {
    let children_12, children_10, children_14;
    const children_16 = [(children_12 = [(children_10 = [react.createElement("th", {}, "Login"), react.createElement("th", {}, "Name"), react.createElement("th", {}, "Letzter Login"), react.createElement("th", {}, "Rechte"), react.createElement("th", {})], react.createElement("tr", {}, ...children_10))], react.createElement("thead", {}, ...children_12)), (children_14 = map_1((user) => tableRow(dispatch, navigateTo, user), users), react.createElement("tbody", {}, ...children_14))];
    return react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch",
    }, ...children_16);
}

export function listPage(users, dispatch, navigateTo) {
    let children_14, children_12, children_10;
    const children_16 = [(children_14 = [(children_12 = [(children_10 = toList(delay(() => {
        let props, children, s;
        return append(singleton((props = [["style", {
            margin: "0.8rem",
        }]], (children = [(s = "Legen Sie hier unterschiedliche Nutzer für das Kundenportal an und ordnen Sie anschließend diesen entsprechende Rechte zu. Benötigt werden hierfür der Name und eine E-Mail-Adresse. Bitte beachten Sie, dass jeder Nutzer eine individuelle Mailadresse benötigt.", s)], react.createElement("p", keyValueList(props, 1), ...children)))), delay(() => {
            let children_4;
            return append(singleton((children_4 = [react.createElement("button", {
                className: "bfsbutton  is-small",
                onClick: (_arg) => {
                    dispatch(new Msg(12, []));
                },
            }, "Neu")], react.createElement("div", {
                className: "new-button-contailer",
            }, ...children_4))), delay(() => {
                const matchValue = users;
                return (matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg("Fehler beim Laden der Benutzer!")) : ((matchValue.tag === 3) ? (equals(matchValue.fields[0], empty_1()) ? singleton(react.createElement("div", {}, "Keine Benutzer vorhanden")) : append(singleton(table(matchValue.fields[0], dispatch, navigateTo)), delay(() => singleton(tableMobile(matchValue.fields[0], dispatch, navigateTo))))) : singleton(react.createElement("div", {}))));
            }));
        }));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_10))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_12))], react.createElement("div", {
        className: "column is-12",
    }, ...children_14))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_16);
}

export function rolesBlock(model, dispatch) {
    let children_20, children_18;
    let addableRoles;
    const matchValue = model.AllUsermanagedRoles;
    addableRoles = ((matchValue.tag === 3) ? List_except(model.UserRoles, matchValue.fields[0], {
        Equals: equals,
        GetHashCode: safeHash,
    }) : empty_1());
    const children_22 = [react.createElement("label", {
        className: "label",
    }, "Rechte"), (children_20 = [(children_18 = toList(delay(() => append(singleton(toArray(map_1((r) => {
        const props_4 = [new HTMLAttr(65, ["tag is-light tooltip is-tooltip-multiline"]), ["data-tooltip", r.Beschreibung]];
        const children_4 = toList(delay(() => append(singleton(r.Bezeichnung), delay(() => ((!model.IsCurrentUser ? true : (r.KundenportalRolleId !== 8)) ? singleton(react.createElement("button", {
            className: "delete is-small",
            onClick: (_arg) => {
                dispatch(new EditUserDialogMsg(6, [r]));
            },
        })) : empty())))));
        return react.createElement("span", keyValueList(props_4, 1), ...children_4);
    }, model.UserRoles))), delay(() => {
        let children_16, children_8, children_6, children_14, children_12;
        return (length(addableRoles) > 0) ? singleton((children_16 = [(children_8 = [(children_6 = [icon("fas fa-plus")], react.createElement("span", {
            className: "tag",
            "aria-haspopup": true,
            "aria-controls": "dropdown-roles",
        }, ...children_6))], react.createElement("div", {
            className: "dropdown-trigger",
        }, ...children_8)), (children_14 = [(children_12 = toList(delay(() => {
            const matchValue_1 = model.AllUsermanagedRoles;
            return (matchValue_1.tag === 1) ? singleton(spinner) : ((matchValue_1.tag === 2) ? singleton(toText(printf("Fehler beim Laden der verwalbaren Rollen: %s"))(matchValue_1.fields[0])) : ((matchValue_1.tag === 3) ? singleton(toArray(map_1((r_1) => {
                const props_10 = [new HTMLAttr(65, ["dropdown-item  tooltip is-tooltip-multiline is-tooltip-right"]), ["data-tooltip", r_1.Beschreibung], new DOMAttr(40, [(_arg_1) => {
                    dispatch(new EditUserDialogMsg(6, [r_1]));
                }])];
                return react.createElement("a", keyValueList(props_10, 1), r_1.Bezeichnung);
            }, addableRoles))) : singleton("Keine verwaltbaren Rollen gefunden")));
        })), react.createElement("div", {
            className: "dropdown-content",
        }, ...children_12))], react.createElement("div", {
            className: "dropdown-menu",
            id: "dropdown-roles",
            role: "menu",
        }, ...children_14))], react.createElement("div", {
            className: "dropdown is-hoverable",
        }, ...children_16))) : empty();
    })))), react.createElement("div", {
        className: "block",
    }, ...children_18))], react.createElement("div", {
        className: "buttons",
    }, ...children_20))];
    return react.createElement("div", {
        className: "field",
    }, ...children_22);
}

export function userDialog(model, dispatch) {
    let children_16, children_4, children_2, children_8, children_6, children_14, props_10;
    const children_18 = [react.createElement("div", {
        className: "modal-background",
    }), (children_16 = [(children_4 = [(children_2 = toList(delay(() => ((model.Id != null) ? singleton("Benutzer bearbeiten") : singleton("Benutzer anlegen")))), react.createElement("p", {
        className: "modal-card-title",
    }, ...children_2))], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_4)), (children_8 = [(children_6 = toList(delay(() => append((model.Id != null) ? ((model.Login.Value === model.Email.Value) ? append(singleton(validatedTextBox((arg_2) => {
        dispatch(new EditUserDialogMsg(4, [arg_2]));
    })("E-Mail-Adresse (zugleich Login)")("email")("")(model.Email)), delay(() => singleton(validatedTextBox((arg_3) => {
        dispatch(new EditUserDialogMsg(5, [arg_3]));
    })("Name")("name")("")(model.Name)))) : append(singleton(validatedTextBoxWithAttributes([new HTMLAttr(79, [true])])((arg_9) => {
        dispatch(new EditUserDialogMsg(3, [arg_9]));
    })("Login")("login")("")(model.Login)), delay(() => append(singleton(validatedTextBox((arg_10) => {
        dispatch(new EditUserDialogMsg(4, [arg_10]));
    })("E-Mail-Adresse")("email")("")(model.Email)), delay(() => singleton(validatedTextBox((arg_11) => {
        dispatch(new EditUserDialogMsg(5, [arg_11]));
    })("Name")("name")("")(model.Name))))))) : append(singleton(validatedTextBox((arg) => {
        dispatch(new EditUserDialogMsg(4, [arg]));
    })("E-Mail-Adresse (zugleich Login)")("email")("")(model.Email)), delay(() => singleton(validatedTextBox((arg_1) => {
        dispatch(new EditUserDialogMsg(5, [arg_1]));
    })("Name")("name")("")(model.Name)))), delay(() => singleton(rolesBlock(model, dispatch)))))), react.createElement("div", {
        className: "info-Block",
    }, ...children_6))], react.createElement("section", {
        className: "modal-card-body overflow-initial",
    }, ...children_8)), (children_14 = [(props_10 = [new HTMLAttr(65, ["bfsbutton "]), new HTMLAttr(79, [!UserEditModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
        dispatch(new EditUserDialogMsg(8, []));
    }])], react.createElement("button", keyValueList(props_10, 1), "Speichern")), react.createElement("button", {
        className: "button",
        onClick: (_arg_1) => {
            dispatch(new EditUserDialogMsg(7, []));
        },
    }, "Abbrechen")], react.createElement("footer", {
        className: "modal-card-foot",
    }, ...children_14))], react.createElement("div", {
        className: "modal-content overflow-initial",
    }, ...children_16))];
    return react.createElement("div", {
        className: "modal is-active",
    }, ...children_18);
}

export function view(model, dispatch, navigateTo) {
    const children = toList(delay(() => append(singleton(listPage(model.Users, dispatch, navigateTo)), delay(() => ((model.ActiveUserDialog != null) ? singleton(userDialog(value_2(model.ActiveUserDialog), (arg) => {
        dispatch(new Msg(11, [arg]));
    })) : empty())))));
    return react.createElement("div", {
        className: "usermanagement",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
